import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DeleteIcon2() {
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "#767782",
                d: "M18.248 6.495l-.559 13.413a.825.825 0 01-.813.778H7.124a.825.825 0 01-.813-.778L5.75 6.495a.457.457 0 00-.913.038l.56 13.413A1.74 1.74 0 007.123 21.6h9.752c.917 0 1.688-.738 1.726-1.654l.56-13.413a.457.457 0 10-.914-.038z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#767782",
                d: "M11.695 8.343v10.362a.457.457 0 00.915 0V8.343a.457.457 0 00-.915 0zM8.192 8.356l.304 10.362a.457.457 0 10.914-.027L9.105 8.33a.457.457 0 10-.913.027zM14.896 8.33L14.59 18.69a.457.457 0 00.914.027l.305-10.362a.457.457 0 00-.914-.027zM4.381 4.99h15.238a.457.457 0 000-.914H4.381a.457.457 0 000 .914z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#767782",
                d: "M9.377 4.55l.326-.815c.087-.217.389-.42.621-.42h3.353c.234 0 .533.202.62.42l.327.816.848-.34-.326-.815c-.226-.566-.861-.996-1.47-.996h-3.352c-.606 0-1.244.432-1.47.996l-.326.815.85.34z"
            })
        ]
    });
}
